import { useTruncationTooltip } from 'components/Kizen/Tooltip';
import EditableText from 'components/Kizen/EditableText';
import styled from '@emotion/styled';

export const EditableField = styled(EditableText)`
  max-width: 100%;
  padding-right: 10px;
`;

const EditableTextEllipsisWithTooltip = ({ description, ...props }) => {
  const [nameTooltipProps, nameTooltip] = useTruncationTooltip({
    description: description,
  });
  return (
    <>
      {nameTooltip}
      <EditableField {...props} {...nameTooltipProps} />
    </>
  );
};
export default EditableTextEllipsisWithTooltip;
